import { Component, inject, Input, OnInit } from '@angular/core';
import {finalize} from "rxjs";
import { NZ_MODAL_DATA, NzModalModule, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ErxService } from '@beautyapp/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { JsonPipe } from '@angular/common';
import { NzDividerComponent } from 'ng-zorro-antd/divider';

@Component({
  selector: 'beautyapp-erx-detail',
  templateUrl: './erx-detail.component.html',
  styleUrls: ['./erx-detail.component.scss'],
  imports: [
    TranslatePipe,
    NzModalModule,
    NzButtonModule,
  ]
})
export class ErxDetailComponent {
  private erxService = inject(ErxService);
  modalRef = inject(NzModalRef);
  private modal = inject(NzModalService);
  private translateService = inject(TranslateService);

  data = inject(NZ_MODAL_DATA)

  prescription = this.data.prescription;
  isLoading = false;

  submit(): void {
    this.modal.confirm({
      nzTitle: this.translateService.instant('ERX.sendTitle'),
      nzContent: this.translateService.instant('ERX.confirmSendPrescription'),
      nzOkDanger: false,
      nzOnOk: () => {
        this.isLoading = true;
        this.erxService.send(this.prescription.id)
          .pipe(finalize(() => {
            this.isLoading = false;
          }))
          .subscribe(() => this.modalRef.triggerOk());
      },
    });
  }

  download(item: any) {
    this.erxService.generateAndSaveRecipe(item.id).subscribe(
      (res) => {
        console.log(res);
        if (res && res.url) {
          // Option 1: Open in new tab
          window.open(res.url, '_blank');
        }
      }
    );
  }
}
